interface OnboardingWelcomeProps {
  onContinue: () => void;
}

export function OnboardingWelcome({ onContinue }: OnboardingWelcomeProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="max-w-md text-center">
        <div className="text-6xl mb-6" aria-hidden="true">
          💰
        </div>

        <h1 className="text-4xl font-bold text-brand-primary mb-4">Budgeter</h1>

        <p className="text-lg text-mid-gray mb-8">
          Controla tus gastos de forma fácil con tus estados de cuenta bancarios
        </p>

        <button
          onClick={onContinue}
          className="px-8 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-secondary transition-colors font-medium text-lg"
        >
          Comenzar →
        </button>
      </div>
    </div>
  );
}
